import { CHECK_SELECTION } from './types';

const CheckSelection = ({ target }) => (
  {
    type: CHECK_SELECTION,
    id: target.id,
  }
);

const Finished = ({ target }) => ({ type: 'FINISHED', id: target.id, completed: true });

export { CheckSelection, Finished };



// WEBPACK FOOTER //
// ./src/actions/CheckSelection.js